<template>
  <div class="pagination-container">
    <paginate v-if="showPager"
      v-model="currentPage_"
      :page-count="pageCount"
      :page-range="pageRange"
      :margin-pages="marginPages"
      :click-handler="onPageClick"
      :prev-text="prevText"
      :next-text="nextText"
      :container-class="pagerContainerClass"
      :page-class="pagerPageClass"
      :page-link-class="pagerPageLinkClass"
      :prev-class="pagerPrevClass"
      :prev-link-class="pagerPrevLinkClass"
      :next-class="pagerNextClass"
      :next-link-class="pagerNextLinkClass">
    </paginate>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'

export default {
  name: 'pagination',
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    itemCount: {
      type: Number,
      required: true
    },
    itemsPerPage: {
      type: Number,
      default: 20
    },
    pageRange: {
      type: Number,
      default: 8
    },
    marginPages: {
      type: Number,
      default: 1
    },
    prevText: {
      type: String,
      default: '前へ'
    },
    nextText: {
      type: String,
      default: '次へ'
    },
    pagerContainerClass: {
      type: String,
      default: 'pagination'
    },
    pagerPageClass: {
      type: String,
      default: 'page-item'
    },
    pagerPageLinkClass: {
      type: String,
      default: 'page-link'
    },
    pagerPrevClass: {
      type: String,
      default: 'page-item'
    },
    pagerPrevLinkClass: {
      type: String,
      default: 'page-link'
    },
    pagerNextClass: {
      type: String,
      default: 'page-item'
    },
    pagerNextLinkClass: {
      type: String,
      default: 'page-link'
    },
  },
  watch: {
    currentPage() {
      this.setCurrentPage()
    }
  },
  data() {
    return {
      currentPage_: 2,
    }
  },
  computed: {
    showPager() {
      return this.itemCount > 0
    },
    pageCount() {
      return Math.ceil(this.itemCount / this.itemsPerPage)
    },
  },
  mounted() {
    this.setCurrentPage()
  },
  methods: {
    setCurrentPage() {
      this.currentPage_ = this.currentPage
    },
    onPageClick(e) {
      this.$emit('click', e)
    }
  },
  components: { Paginate }
}
</script>

<style lang="scss" scoped>
.pagination-container {
  display: flex;
  justify-content: center;
  margin: 8px 0;
}
.pagination {
  margin: 0;
}
</style>
